import React from 'react';

import type { FlexProps } from '@zillow/constellation';
import { Flex } from '@zillow/constellation';

interface ContainerProps {
    gap: FlexProps['gap'];
}

export const Container: React.FC<React.PropsWithChildren<ContainerProps>> = ({ children, gap }) => (
    <Flex display="flex" flexDirection="column" gap={gap}>
        {children}
    </Flex>
);
